var render = function render(){var _vm=this,_c=_vm._self._c;return _c('balance',{ref:"balance",attrs:{"title":_vm.title,"cols":_vm.headers,"url":"reports/balance","defaultFilters":_vm.defaultFilters}})
}
var staticRenderFns = []

export { render, staticRenderFns }